<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
* {
  -webkit-user-select: text;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-user-select: text;
  text-align: left;
  color: #2c3e50;
}

.cube-tab-bar {
  i {
    font-size: 20px;
  }

  .cube-tab {
    font-size: 14px;
  }
}

.left {
  float: left;
}

.right {
  float: right;
}

.flex {
  display: flex;
}

.fixed {
  position: fixed;
}

.container {
  width: 1200px;
  margin: 10px auto;
}

.center {
  text-align: center;
}

.flex {
  display: flex;
}

ul, li {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue